import { render, staticRenderFns } from "./secondary-nav.vue?vue&type=template&id=f3aa2f4a&"
import script from "./secondary-nav.vue?vue&type=script&lang=ts&"
export * from "./secondary-nav.vue?vue&type=script&lang=ts&"
import style0 from "./secondary-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports